import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {Meta, MetaDefinition} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {firstValueFrom} from 'rxjs';
import {HeaderEnum} from '../../enums/routes-header.enum';

interface MetaTags {
  url: string;
  site_name: string;
  title: string;
  description: string;
  image: string;
}

interface MetaObject {
  homepage?: MetaTags;
  energia?: MetaTags;
  allianzPay?: MetaTags;
}

@Injectable({
  providedIn: 'root',
})
export class MetaHandlerService {
  private metaObject: MetaObject = {};

  constructor(
    private meta: Meta,
    private translateService: TranslateService,
  ) {}

  private async recoverMetaTags(type?: keyof typeof HeaderEnum): Promise<MetaTags> {
    const data = this.translateService.instant(`${type ?? 'homepage'}.metaTags`);
    if (typeof data === 'object') return data;

    return await firstValueFrom(this.translateService.get(`${type ?? 'homepage'}.metaTags`));
  }

  async updateTags(type?: keyof typeof HeaderEnum) {
    const metaObj = await this.recoverMetaTags(type);
    const metaTags = <(keyof MetaTags)[]>Object.keys(metaObj);

    if (typeof metaObj === 'string') {
      return;
    }

    metaTags.forEach((key) => {
      const metaDef: MetaDefinition = {property: `og:${key}`, content: metaObj[key]};
      this.meta.updateTag(metaDef);
      return metaDef;
    });
  }
}
